import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { DESKTOP_BREAKPOINT } from '../constants';

/** Text trigger shared by Rewards / Tools. */
export const NavHoverTrigger = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'highlighted' && prop !== 'isOpen',
})<{ highlighted?: boolean; isOpen?: boolean }>(({ theme, highlighted, isOpen }) => ({
  minWidth: 0,
  padding: '8px',
  fontSize: '0.75rem',
  fontWeight: 500,
  textTransform: 'none',
  lineHeight: 1.25,
  color: highlighted ? 'var(--mui-palette-text-primary)' : 'var(--mui-palette-text-secondary)',
  '&:hover': {
    backgroundColor: 'transparent',
    color: 'var(--mui-palette-text-primary)',
  },
  '& .MuiButton-endIcon': {
    marginLeft: 'calc(0.5 * var(--mui-spacing))',
    transition: 'transform 150ms',
    transform: `rotate(${isOpen ? 180 : 0}deg)`,
  },
  '& .MuiButton-endIcon > svg': {
    fontSize: '1rem',
  },
  [theme.breakpoints.down(DESKTOP_BREAKPOINT)]: {
    display: 'none',
  },
}));

export const navHoverTriggerEndIcon = <ExpandMoreIcon />;
